import { useI18next } from "@zestia/gatsby-plugin-react-i18next"

export const formatNumber = (number, options = {}) => {
  const { language } = useI18next()

  return Intl.NumberFormat(language, options).format(number)
}
